// extracted by mini-css-extract-plugin
export var active = "_d0-7";
export var container = "_d0-0";
export var evenWidth = "_d0-4";
export var large = "_d0-5";
export var outlet = "_d0-8";
export var slide = "_d0-2";
export var small = "_d0-6";
export var tab = "_d0-3";
export var tabs = "_d0-1";